import axios from "axios";
import apis from "../../../lib/apis/apis";
import { apiHeaders } from "../../../lib/apiHeader";
import {
  mockOverview,
  mockCustomers,
  mockSaves,
  mockInsights,
  mockContactLog,
  mockStoreContact,
} from "./mockData";

// Flip to false when the Laravel endpoints from the spec's §6 contract ship.
export const USE_CHURN_MOCKS = false;

const delay = (data, ms = 400) =>
  new Promise((resolve) => setTimeout(() => resolve(data), ms));

const get = async (url, params) => {
  const response = await axios.get(url, { params, headers: apiHeaders() });
  if (response?.data?.success === "true") return response.data.data;
  throw new Error(response?.data?.message || "Request failed");
};

export const churnApi = {
  getOverview: (params) =>
    USE_CHURN_MOCKS ? delay(mockOverview(params)) : get(apis.churn_overview, params),
  getCustomers: (params) =>
    USE_CHURN_MOCKS ? delay(mockCustomers(params)) : get(apis.churn_customers, params),
  getSaves: (params) =>
    USE_CHURN_MOCKS ? delay(mockSaves(params)) : get(apis.churn_saves, params),
  getInsights: (userId) =>
    USE_CHURN_MOCKS
      ? delay(mockInsights(userId))
      : get(`${apis.customer_insights}${userId}/insights`),
  getContactLog: (params) =>
    USE_CHURN_MOCKS ? delay(mockContactLog(params)) : get(apis.contact_log, params),
  storeContactLog: async (payload) => {
    if (USE_CHURN_MOCKS) return delay(mockStoreContact(payload));
    const response = await axios.post(apis.contact_log, payload, {
      headers: apiHeaders(),
    });
    if (response?.data?.success === "true") return response.data.data;
    throw new Error(response?.data?.message || "Request failed");
  },
};
